import React from 'react';
import BoardSprite from "./BoardSprite"
import { gameStateManager } from '../../App';
import { useEffect, useState } from "react";
import { utils } from '../../utils';

const BoardMeeple = ( { textureCache, anchorOffset = { x: 0, y: 0 }, ...props } ) =>
{
  return (
    <BoardSprite
      anchor={ { x: 0.5 + anchorOffset.x, y: 0.75 + anchorOffset.y } }
      textureCache={ textureCache }
      { ...props }
    />
  );
};

const PixiBoardMeeplesHandler = ( { textureCache, meepleTileHashes, meepleTileCoords, meepleLocalCoords, meepleIsFarmerStatus, meepleTeamColourID } ) =>
{
  const [ renderScale, setRenderScale ] = useState( 1.0 );

  useEffect( () =>
  {
    let onStageRenderDataChanged = ( stageRenderData ) =>
    {
      setRenderScale( stageRenderData.scale );
    };

    let currentStageRenderData = gameStateManager.addOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    setRenderScale( currentStageRenderData.scale );

    return () =>
    {
      gameStateManager.removeOnStageRenderDataChangeCallback( onStageRenderDataChanged );
    };
  }, [] ); // Empty dependency array means "run once"




  // console.log( 'MEEPS HANDLER RENDERING', meepleTileHashes );

  let teamBoardMeepleSprites = [];

  for( let idx = 0; idx < meepleTileHashes.length; idx++ )
  {
    teamBoardMeepleSprites.push(

      <BoardMeeple
        key={ `boardMeeple_${meepleTileHashes[ idx ]}_${meepleLocalCoords[ idx ].x}_${meepleLocalCoords[ idx ].y}` }
        animSteps={
          [
            {
              fromOffsetX: 100,
              fromOffsetY: -150,
              fromAlpha: 0,
              toOffsetX: 0,
              toOffsetY: -50,
              toAlpha: 0.5,
              duration: 1000, // ms
              easing: "linear"
            },
            {
              fromOffsetX: 0,
              fromOffsetY: -50,
              fromAlpha: 0.5,
              toOffsetX: 0,
              toOffsetY: 0,
              toAlpha: 1,
              duration: 500, // ms
              easing: "inOutSine"   // TODO: Add support for different easing functions
            }
          ]
        }
        imageSrc={ utils.getAssetPath(`./meeples/Meeple - ${meepleIsFarmerStatus[ idx ] ? 'Farmer' : 'Standard'} - ${meepleTeamColourID[ idx ]}.png`) }
        renderScale={ renderScale }
        textureCache={ textureCache }
        x={ meepleTileCoords[ idx ].x + meepleLocalCoords[ idx ].x }
        y={ - 1 * ( meepleTileCoords[ idx ].y + meepleLocalCoords[ idx ].y ) }
        anchorOffset={ meepleIsFarmerStatus[ idx ] ? { x: -0.06, y: 0.12 } : { x: -0.0, y: 0.05 } }
      />
    );
  }

  return (
    <>
      { teamBoardMeepleSprites }
    </>
  );
}

export default React.memo( PixiBoardMeeplesHandler,
  ( prevProps, nextProps ) =>
  {
    // Comparison check
    // console.log( "COMP CHECK prevProps: ", prevProps, ", nextProps: ", nextProps );

    // Check for any change to the meeples data
    if( prevProps.meepleTileHashes.length !== nextProps.meepleTileHashes.length )
    {
      return false;
    }

    // A meeple could've been added at the same time as one being returned, so check for individual tile hash changes
    for( let idx = 0; idx < prevProps.meepleTileHashes.length; idx++ )
    {
      if( prevProps.meepleTileHashes[ idx ] !== nextProps.meepleTileHashes[ idx ] )
      {
        return false;
      }
    }

    return true;
  }
);
